import { Component } from '@angular/core';
import { PipesModule } from '../../../pipes/pipes.module';

@Component({
  selector: 'app-testimonials',
  standalone: true,
  imports: [PipesModule],
  templateUrl: './testimonials.component.html',
  styleUrl: './testimonials.component.scss'
})
export class TestimonialsComponent {

}
